/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CaseFileLiteInfo,
    CaseFileLiteInfoFromJSON,
    CaseFileLiteInfoFromJSONTyped,
    CaseFileLiteInfoToJSON,
    CaseFileType,
    CaseFileTypeFromJSON,
    CaseFileTypeFromJSONTyped,
    CaseFileTypeToJSON,
    CaseFolder,
    CaseFolderFromJSON,
    CaseFolderFromJSONTyped,
    CaseFolderToJSON,
    DocumentStatus,
    DocumentStatusFromJSON,
    DocumentStatusFromJSONTyped,
    DocumentStatusToJSON,
    ParentRelationship,
    ParentRelationshipFromJSON,
    ParentRelationshipFromJSONTyped,
    ParentRelationshipToJSON,
    Source,
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface CaseFileLite
 */
export interface CaseFileLite {
    /**
     * 
     * @type {ParentRelationship}
     * @memberof CaseFileLite
     */
    parentRelationship?: ParentRelationship;
    /**
     * 
     * @type {Source}
     * @memberof CaseFileLite
     */
    source: Source;
    /**
     * 
     * @type {DocumentStatus}
     * @memberof CaseFileLite
     */
    status: DocumentStatus;
    /**
     * 
     * @type {CaseFileType}
     * @memberof CaseFileLite
     */
    type: CaseFileType;
    /**
     * 
     * @type {string}
     * @memberof CaseFileLite
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileLite
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileLite
     */
    uploadedBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFileLite
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof CaseFileLite
     */
    uploadDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof CaseFileLite
     */
    fileSize?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFileLite
     */
    parentDocumentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFileLite
     */
    caseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFileLite
     */
    clientId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CaseFileLite
     */
    pageCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CaseFileLite
     */
    mimeType?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CaseFileLite
     */
    uploadedByClient: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseFileLite
     */
    isWithheld: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseFileLite
     */
    isPrivileged: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseFileLite
     */
    folderId?: string | null;
    /**
     * 
     * @type {CaseFolder}
     * @memberof CaseFileLite
     */
    folder?: CaseFolder;
    /**
     * 
     * @type {CaseFileLiteInfo}
     * @memberof CaseFileLite
     */
    info?: CaseFileLiteInfo;
    /**
     * 
     * @type {boolean}
     * @memberof CaseFileLite
     */
    hasResponsiveFile?: boolean | null;
}

export function CaseFileLiteFromJSON(json: any): CaseFileLite {
    return CaseFileLiteFromJSONTyped(json, false);
}

export function CaseFileLiteFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFileLite {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parentRelationship': !exists(json, 'parentRelationship') ? undefined : ParentRelationshipFromJSON(json['parentRelationship']),
        'source': SourceFromJSON(json['source']),
        'status': DocumentStatusFromJSON(json['status']),
        'type': CaseFileTypeFromJSON(json['type']),
        'id': json['id'],
        'userId': json['userId'],
        'uploadedBy': !exists(json, 'uploadedBy') ? undefined : json['uploadedBy'],
        'name': json['name'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
        'fileSize': !exists(json, 'fileSize') ? undefined : json['fileSize'],
        'parentDocumentId': !exists(json, 'parentDocumentId') ? undefined : json['parentDocumentId'],
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
        'mimeType': !exists(json, 'mimeType') ? undefined : json['mimeType'],
        'uploadedByClient': json['uploadedByClient'],
        'isWithheld': json['isWithheld'],
        'isPrivileged': json['isPrivileged'],
        'folderId': !exists(json, 'folderId') ? undefined : json['folderId'],
        'folder': !exists(json, 'folder') ? undefined : CaseFolderFromJSON(json['folder']),
        'info': !exists(json, 'info') ? undefined : CaseFileLiteInfoFromJSON(json['info']),
        'hasResponsiveFile': !exists(json, 'hasResponsiveFile') ? undefined : json['hasResponsiveFile'],
    };
}

export function CaseFileLiteToJSON(value?: CaseFileLite | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parentRelationship': ParentRelationshipToJSON(value.parentRelationship),
        'source': SourceToJSON(value.source),
        'status': DocumentStatusToJSON(value.status),
        'type': CaseFileTypeToJSON(value.type),
        'id': value.id,
        'userId': value.userId,
        'uploadedBy': value.uploadedBy,
        'name': value.name,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
        'fileSize': value.fileSize,
        'parentDocumentId': value.parentDocumentId,
        'caseId': value.caseId,
        'clientId': value.clientId,
        'pageCount': value.pageCount,
        'mimeType': value.mimeType,
        'uploadedByClient': value.uploadedByClient,
        'isWithheld': value.isWithheld,
        'isPrivileged': value.isPrivileged,
        'folderId': value.folderId,
        'folder': CaseFolderToJSON(value.folder),
        'info': CaseFileLiteInfoToJSON(value.info),
        'hasResponsiveFile': value.hasResponsiveFile,
    };
}


